import { computed } from 'vue'
import { Store } from 'vuex'
import { State as StoreState } from '@/store/index'
import { useStoreAction } from '@/model/store/store'
import { MENU_LIST, MENU_TYPE } from './sideMenuType'

/**
 * メニューの関数を返す
 * @param store vuex
 * @returns メニューの関数を返す
 */
const useMenu = (store: Store<StoreState>) => {
  /**
   * 選択状態を返す
   */
  const isSelected = computed(
    () =>
      (type: MENU_TYPE): boolean =>
        type === store.getters.selectMenu
  )
  /**
   * メニュー情報を更新する
   * @param type メニュー種別
   */
  const update = (type: MENU_TYPE) => {
    useStoreAction(store).menu(type)
  }
  return {
    isSelected,
    update,
    MENU_LIST,
  }
}
export { useMenu }
